import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useActivateSafeFromUrlParam } from 'hooks';
import { Iframe } from 'pages/AppsPage/components/Iframe';
import { useAppsIframe } from 'store';

import { STACKING_URL } from './constants';

type Props = {
  url?: string;
};

export const StackingPage: React.FC<Props> = ({ url = '' }) => {
  useActivateSafeFromUrlParam();
  const location = useLocation();
  const { setIframeRun, setSidebarHidden } = useAppsIframe();

  useEffect(() => {
    setIframeRun(true);
    setSidebarHidden(true);
  }, [location.pathname]);

  return (
    <div className="flex w-full h-[100vh]">
      <div className="flex flex-col w-full p-0 overflow-y-scroll h-[100vh]">
        <Iframe url={url ? url : STACKING_URL} />
      </div>
    </div>
  );
};
